"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconSizes = exports.IconSize = void 0;
var polished_1 = require("polished");
var IconSize;
(function (IconSize) {
    IconSize["Small"] = "small";
    IconSize["Medium"] = "medium";
    IconSize["Large"] = "large";
})(IconSize = exports.IconSize || (exports.IconSize = {}));
exports.iconSizes = (_a = {},
    _a[IconSize.Small] = (0, polished_1.rem)(12),
    _a[IconSize.Medium] = (0, polished_1.rem)(16),
    _a[IconSize.Large] = (0, polished_1.rem)(20),
    _a);
